import React from "react";
import PageLayout from "../components/PageLayout";

export default function Catalogo() {
  const cards = [
    {
      title: "Catálogo de cursos",
      text: "Conheça áreas, objectivos, duração e perfil recomendado para cada formação.",
      points: ["Cursos regulares", "Cursos intensivos", "Formação empresarial"],
    },
    {
      title: "Catálogo de serviços",
      text: "Consulte possibilidades em tecnologia, gráfica, repografia e suporte profissional.",
      points: [
        "Serviços individuais",
        "Soluções combinadas",
        "Planos empresariais",
      ],
    },
    {
      title: "Catálogo de personalizados",
      text: "Explore materiais e brindes que podem receber a identidade da sua organização.",
      points: ["Eventos", "Equipas", "Campanhas"],
    },
  ];
  return (
    <PageLayout
      eyebrow="Catálogo"
      title="Tudo o que o CENFOTEP pode fazer por si."
      intro="Use o catálogo para identificar a área de interesse e fale com a equipa para confirmar detalhes, disponibilidade, prazo e investimento."
      sectionTitle="Explore por categoria"
      sectionIntro="Organizámos a oferta para tornar a consulta simples, mesmo quando ainda não sabe exactamente qual serviço escolher."
      cards={cards}
    />
  );
}
